var map = {
	"./bitcoin.svg": 250,
	"./discord.svg": 251,
	"./document.svg": 252,
	"./event.svg": 253,
	"./facebook.svg": 254,
	"./gmail.svg": 255,
	"./heart.svg": 256,
	"./instagram.svg": 257,
	"./linkedin.svg": 258,
	"./phone.svg": 259,
	"./pinterest.svg": 260,
	"./soundcloud.svg": 261,
	"./twitter.svg": 262,
	"./wifi.svg": 263,
	"./youtube.svg": 264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 249;